// FIXME: the same colors are used in the backend, so we should have a shared file for this,  see $available_colors
export const availableColors = [
    '#ffc26f', // in zone: #fec16f - UPDATE zone SET color='#ffc26f' WHERE color='#fec16f';
    '#f56c7e', // in zone: #f86a7d - UPDATE zone SET color='#f56c7e' WHERE color='#f86a7d';
    '#70a0ff', // in zone: #6fa0ff - UPDATE zone SET color='#70a0ff' WHERE color='#6fa0ff';
    '#96de7e', // in zone: #97de7e - UPDATE zone SET color='#96de7e' WHERE color='#97de7e';
    '#ba71eb', // in zone: #bb71ec - UPDATE zone SET color='#ba71eb' WHERE color='#bb71ec';
    '#86eaf7', // in zone: #86ebf7 - UPDATE zone SET color='#86eaf7' WHERE color='#86ebf7';
    '#86f7be', // in zone: #85f6be - UPDATE zone SET color='#86f7be' WHERE color='#85f6be';
    '#74d6a8', // in zone: #73d4a7 - UPDATE zone SET color='#74d6a8' WHERE color='#73d4a7';
    '#c7f587',
    '#e8e8a0',
    '#fae06e',
    '#ffa87d',
    '#ff7e5e',
    '#d1665e',
    '#ff7abd',
    '#d65ec2',
    '#9580ff',
    '#89c5f0',
];

const missingColors = ['#73d4a7', '#85f6be', '#86ebf7'];
